import { render, staticRenderFns } from "./JobSummary.vue?vue&type=template&id=0f0353ae&"
import script from "./JobSummary.vue?vue&type=script&lang=js&"
export * from "./JobSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports